export const RGB_COLOR_REGEX = /\((\d+),\s*(\d+),\s*(\d+)(,\s*(\d*.\d*))?\)/;
export default class Color {
    constructor(r, g, b, a) {
        if (typeof r === 'string') {
            r = r.trim();
            if (r.indexOf('#') === 0) {
                r = r.substr(r.indexOf('#') + 1);
                this.r = parseInt(r.substr(0, 2), 16);
                this.g = parseInt(r.substr(2, 2), 16);
                this.b = parseInt(r.substr(4, 2), 16);
            }
            else if (r.indexOf('rgb') === 0) {
                const match = RGB_COLOR_REGEX.exec(r);
                this.r = parseInt(match[1], 10);
                this.g = parseInt(match[2], 10);
                this.b = parseInt(match[3], 10);
                this.a = match[5] ? parseFloat(match[5]) : 1;
            }
        }
        else {
            this.r = r;
            this.g = g;
            this.b = b;
            this.a = a || 1;
        }
    }
    toHex() {
        return `#${this.r.toString(16)}${this.g.toString(16)}${this.b.toString(16)}`;
    }
    toRgb() {
        return `rgb(${this.r}, ${this.g}, ${this.b})`;
    }
    toRgba() {
        return `rgba(${this.r}, ${this.g}, ${this.b}, ${this.a})`;
    }
    isEqual(color) {
        return this.r === color.r && this.g === color.g && this.b === color.b && this.a === color.a;
    }
}
//# sourceMappingURL=Color.js.map